export const teoriaRealEstateToken = [
    {
      title: "¿Qué información incluye un contrato de tokenización inmobiliaria (Real Estate Token)?",
      value: `
  Antes de crear tu contrato inteligente para tokenizar un bien raíz, es fundamental tener bien documentada y organizada toda la información del activo que vas a representar.  
  Esta documentación aporta confianza y transparencia tanto para inversionistas como para autoridades, y es la base sobre la que se construye el valor del token.
  
  En el ejemplo de tokenización de un inmueble de renta, la información más relevante que se debe incluir es:
  
  ---
  
  - **Descripción del activo:**  
    Breve explicación del tipo de propiedad (ej. departamento, local comercial, edificio en renta).
  
  - **Referencia visual:**  
    Enlace al plano de la propiedad, imágenes, o incluso un link a Google Maps para comprobar su existencia física y dimensiones.
  
  - **Dirección física:**  
    La ubicación exacta y verificable del inmueble.
  
  - **Ingresos y proyecciones:**  
    Monto de renta mensual o anual estimado, para que los potenciales compradores o inversionistas conozcan la rentabilidad.
  
  - **Prueba de título:**  
    Documento que certifica la propiedad, como la escritura o el registro público, con número de registro y/o enlace al organismo oficial correspondiente.
  
  - **Seguro del inmueble:**  
    Comprobante del seguro vigente, incluyendo nombre de la compañía aseguradora y número de póliza, para mitigar riesgos.
  
  - **Datos del propietario:**  
    Nombre(s) y dirección del o los titulares actuales del inmueble, pudiendo incluir también enlaces a perfiles públicos (LinkedIn, web oficial, etc.) para dar transparencia y confianza.
  
  - **Precio de compra original y valor actual:**  
    Incluye la fecha de compra, el precio inicial y una tasación reciente o certificado de valor actual, con enlaces o documentos adjuntos.
  
  - **Acuerdo de compra-venta:**  
    Contrato legal que respalda la compra del activo, preferentemente con acceso a una copia digital o link.
  
  - **Certificado notarial:**  
    Enlace a un documento notarizado que autentica la información proporcionada en el contrato.
  
  - **Nombre y características del token:**  
    Elige un nombre único para tu token (ej. MyRealToken), especifica qué porcentaje o valor representa cada token, y establece el precio inicial estimado.
  
  - **Total de tokens emitidos:**  
    Define la cantidad total de tokens que existirán, lo que otorga escasez y transparencia al proyecto.
  
  - **Derechos adicionales:**  
    Aclara si los tokens otorgan derechos a dividendos, voto, acceso a servicios, etc. Si no aplica, déjalo en blanco o especifica "no aplicable".
  
  - **Fecha y firma:**  
    Fecha de creación del contrato y, si es posible, firma o identificación del responsable legal.
  
  ---
  
  Toda esta información **no solo cumple una función legal y contable, sino que también facilita la confianza de los futuros inversionistas**, quienes podrán auditar, verificar y entender el activo que respalda a tu token digital.
  
  En el siguiente paso, aprenderás cómo integrar estos datos a tu contrato inteligente para que la tokenización de tu activo sea transparente y profesional desde el inicio.
  `
    }
  ];
  
  export default teoriaRealEstateToken;
  